import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';
import { ITeamLevelDTO, TeamLevelDTO } from './team.level.dto';

export interface ICriteriaCountTeamLevelDTO extends IBaseEntityDTO {
  team_level?: ITeamLevelDTO;
  mandatory_number: number;
}

export class CriteriaCountTeamLevelDTO extends BaseEntityDTO implements ICriteriaCountTeamLevelDTO {
  team_level?: ITeamLevelDTO;
  mandatory_number: number;

  constructor(data?: Partial<CriteriaCountTeamLevelDTO>) {
    super(data);
    this.team_level = data?.team_level ? new TeamLevelDTO(data?.team_level) : undefined;
    this.mandatory_number = data?.mandatory_number ?? 0;
  }
}
